import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.99945 13.3332L0.550781 8.88449L1.24695 8.18832L4.49945 11.4307V0.660156H5.49945V11.4242L8.75195 8.17166L9.44811 8.88449L4.99945 13.3332Z",
      fill: "#6E6E6E"
    }, null, -1)
  ]))]))
}
export default { render: render }